import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Auth is session-only. On every startup (i.e. opening a new browser) drop any `user`
// persisted in localStorage so a stale token from an older build can never restore a
// session. sessionStorage is untouched, so an in-session reload stays logged in.
localStorage.removeItem("user");

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
